import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/room-type`
  const result = await bService.get(url)

  return result
}

const create = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/room-type`
  const result = await bService.post(url, data)

  return result
}

const update = async (hotelId, roomTypeId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/room-type/${roomTypeId}`
  const result = await bService.put(url, data)

  return result
}

const remove = async (hotelId, roomTypeId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/room-type/${roomTypeId}`
  const result = await bService.remove(url)

  return result
}

export default {
  list,
  create,
  update,
  remove
}
